export const organizationsNames = {
  hoya: "hoya",
  hoyaSidewall: "hoya-sidewall",
  nagasaka: "nagasaka",
  averroes: "averroes",
  abi: "abi",
  ZeitView: "zeitview",
};
